import { createReducer, combineReducers } from '@reduxjs/toolkit';

import { Nullable } from 'modules/types/common';

import { ShareMedicalHistory } from 'store/medicalHistory/types';
import * as actions from './actions';

export interface ShareMedicalHistoryState {
  isSendingMedicalHistory: boolean;
  sharedMedicalHistoryData: ShareMedicalHistory | {};
  sharedMedicalHistoryError: Nullable<Error>;
}

export interface MedicalHistoryDownloadsState {
  isDownloading: boolean;
  error: Nullable<Error>;
}

export interface MedicalHistoryState {
  shareMedicalHistory: ShareMedicalHistoryState;
  downloadMedicalHistory: MedicalHistoryDownloadsState;
}

export const shareMedicalHistoryInitialState = (): ShareMedicalHistoryState => ({
  isSendingMedicalHistory: false,
  sharedMedicalHistoryData: {},
  sharedMedicalHistoryError: null
});

const shareMedicalHistoryReducer = createReducer(shareMedicalHistoryInitialState(), {
  [actions.SHARE_MEDICAL_HISTORY]: state => {
    state.isSendingMedicalHistory = true;
    state.sharedMedicalHistoryError = null;
  },
  [actions.SHARE_MEDICAL_HISTORY_SUCCESS]: (state, action) => {
    state.isSendingMedicalHistory = false;
    state.sharedMedicalHistoryData = action.payload.data;
  },
  [actions.SHARE_MEDICAL_HISTORY_FAIL]: (state, action) => {
    state.isSendingMedicalHistory = false;
    state.sharedMedicalHistoryError = action.error;
  }
});

export const medicalHistoryDownloadsInitialState = (): MedicalHistoryDownloadsState => ({
  isDownloading: false,
  error: null
});

const medicalHistoryDownloadsReducer = createReducer(medicalHistoryDownloadsInitialState(), {
  [actions.DOWNLOAD_MEDICAL_HISTORY]: state => {
    state.isDownloading = true;
    state.error = null;
  },
  [actions.DOWNLOAD_MEDICAL_HISTORY_SUCCESS]: state => {
    state.isDownloading = false;
  },
  [actions.DOWNLOAD_MEDICAL_HISTORY_FAIL]: (state, action) => {
    state.isDownloading = false;
    state.error = action.error;
  }
});

export default combineReducers({
  shareMedicalHistory: shareMedicalHistoryReducer,
  downloadMedicalHistory: medicalHistoryDownloadsReducer
});
